<div class="p-3 bg-white rounded-2xl border border-black space-y-4">
    <div class="flex flex-wrap items-center justify-between gap-2 border-b-2 border-black pb-2">
        <h4 class="text-xs font-bold uppercase tracking-[0.2em] text-black">
            Variaciones
            @if(variations.length){
            <span class="ml-2 normal-case tracking-normal font-normal text-neutral-600">
                ({{ variations.length }} · stock total {{ totalStock }})
            </span>
            }
        </h4>
        @if(loading()){
        <span class="text-xs text-neutral-500">Cargando...</span>
        }
    </div>

    <!-- Generador -->
    @if(!productTypeId){
    <p class="text-sm text-neutral-600">
        Asigna un <strong>tipo de producto</strong> con atributos de variación (talla, color...) y guarda el producto para poder crear variaciones.
    </p>
    } @else if(!attributes.length){
    <p class="text-sm text-neutral-600">
        El tipo de producto no tiene atributos de variación. Añádelos desde <strong>Tipos de producto</strong>.
    </p>
    } @else {
    <div class="space-y-2">
        @for(attribute of attributes; track attribute.id){
        <div class="flex flex-wrap items-center gap-1.5">
            <span class="w-24 text-xs font-bold uppercase text-neutral-700">{{ attribute.name }}</span>
            @for(term of attribute.terms; track term.id){
            <button type="button" (click)="toggleTerm(term.id)"
                class="cursor-pointer px-2.5 py-1 text-xs rounded-full border transition-colors"
                [class.bg-black]="selectedTermIds.has(term.id)" [class.text-white]="selectedTermIds.has(term.id)"
                [class.border-black]="selectedTermIds.has(term.id)" [class.border-neutral-300]="!selectedTermIds.has(term.id)">
                {{ term.value }}
            </button>
            }
        </div>
        }
        <div class="flex items-center gap-3">
            <button type="button" (click)="generate()" [disabled]="loading() || !combinationsCount"
                class="cursor-pointer px-3 py-1.5 text-sm font-medium bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-40">
                Generar variaciones
            </button>
            @if(combinationsCount){
            <span class="text-xs text-neutral-600">{{ combinationsCount }} combinación(es); las que ya existan se omiten.</span>
            }
        </div>
    </div>
    }

    <!-- Listado -->
    @if(variations.length){
    <div class="flex flex-wrap items-end gap-2 p-2 bg-neutral-50 rounded-xl border border-dashed border-black">
        <span class="text-xs font-bold text-neutral-700 self-center">
            Edición masiva ({{ selectedVariationIds.size ? selectedVariationIds.size + ' seleccionadas' : 'todas' }}):
        </span>
        <label class="text-xs">
            <span class="block text-neutral-600">Precio ticket €</span>
            <input type="text" inputmode="decimal" decimalInput [(ngModel)]="bulk.price_ticket"
                class="w-24 px-2 py-1 text-sm border border-black rounded-lg bg-white">
        </label>
        <label class="text-xs">
            <span class="block text-neutral-600">Precio compra €</span>
            <input type="text" inputmode="decimal" decimalInput [(ngModel)]="bulk.cost"
                class="w-24 px-2 py-1 text-sm border border-black rounded-lg bg-white">
        </label>
        <label class="text-xs">
            <span class="block text-neutral-600">Stock</span>
            <input type="text" inputmode="decimal" decimalInput [decimals]="3" [(ngModel)]="bulk.stock"
                class="w-24 px-2 py-1 text-sm border border-black rounded-lg bg-white">
        </label>
        <button type="button" (click)="applyBulk()" [disabled]="loading()"
            class="cursor-pointer px-3 py-1.5 text-sm font-medium bg-black text-white rounded-lg hover:bg-neutral-800 disabled:opacity-40">
            Aplicar
        </button>
    </div>

    <div class="overflow-x-auto">
        <table class="w-full text-sm">
            <thead>
                <tr class="text-left text-xs uppercase text-neutral-600 border-b border-black">
                    <th class="py-1 pr-2">
                        <input type="checkbox" [checked]="selectedVariationIds.size === variations.length"
                            (change)="toggleAllVariations()" aria-label="Seleccionar todas">
                    </th>
                    <th class="py-1 pr-2">Referencia</th>
                    <th class="py-1 pr-2">Variación</th>
                    <th class="py-1 pr-2 text-right">P. compra</th>
                    <th class="py-1 pr-2 text-right">P. ticket</th>
                    <th class="py-1 pr-2 text-right">Stock</th>
                    <th class="py-1"></th>
                </tr>
            </thead>
            <tbody>
                @for(variation of variations; track variation.id){
                <tr class="border-b border-neutral-200">
                    <td class="py-1 pr-2">
                        <input type="checkbox" [checked]="selectedVariationIds.has(variation.id)"
                            (change)="toggleVariation(variation.id)" [attr.aria-label]="'Seleccionar ' + variation.name">
                    </td>
                    <td class="py-1 pr-2 font-mono text-xs">{{ variation.code }}</td>
                    <td class="py-1 pr-2">{{ termLabel(variation) }}</td>
                    <td class="py-1 pr-2 text-right" [centToEurDisplay]="variation.cost"></td>
                    <td class="py-1 pr-2 text-right" [centToEurDisplay]="variation.price_ticket"></td>
                    <td class="py-1 pr-2 text-right">{{ +variation.stock }}</td>
                    <td class="py-1 text-right whitespace-nowrap">
                        <button type="button" (click)="openEditForm(variation)"
                            class="cursor-pointer px-2 py-0.5 text-xs border border-black rounded hover:bg-neutral-100">Editar</button>
                        <button type="button" (click)="openDeleteForm(variation)"
                            class="cursor-pointer ml-1 px-2 py-0.5 text-xs text-red-600 border border-red-300 rounded hover:bg-red-50">Eliminar</button>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    }
</div>
